
  
   (function(){
    'use strict';

    function formatReal( int ){
            var tmp = int+'';
            tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
            if( tmp.length > 6 )
                    tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");
            return tmp;
    }

    function addZeroes(num) {
        return num.toLocaleString("en", {useGrouping: false, minimumFractionDigits: 2}).toString().replace('.', ',')
     }
    
 
    function addCartKit(){
        
        $('[data-kit="true"] #AddToCart-kit, #AddToCart-kit-now').on('click', function(){
            //loading
            $('.modalOverly').show();
            $('.loadingBox').show();

            //add kit now
            var addNow = false;
            if($(this).attr('id') == 'AddToCart-kit-now'){
                addNow = true;
            }

            //valida se todos itens do kit foram selecionados
            let allItemsSelected = $('.productKit .swatch-item-kit:not(.is-selected)')[0] ? false : true;
            if(allItemsSelected){
                //checo se ja exite o kit no carrinho
                var thisHandle = $('.divKit').attr('data-handle');
                var isKitInCart = false;
                jQuery.getJSON('/cart.js', function(cart) {
                    for (let i = 0; i < cart.items.length; i++) {
                        if(cart.items[i].properties != null){
                            if(cart.items[i].properties.namekit != undefined){
                                $('.modalOverly').hide();
                                $('.loadingBox').hide();
                                isKitInCart = true;
                            }
                        }
                    }
                }).done(function( data ) {
                    
                    //informa que ja existe kit no carrinho
                    if(isKitInCart == true){
                        Swal.fire({
                            icon: 'info',
                            html: '<p>Não é possivel comprar 2 Kits no mesmo pedido.</p>',
                        })
                    }else{
                        var items = [];
                        var quantityItems = parseInt($('.qtyField input#quantity').val());
                        var randomNumber = Math.floor(Math.random() * (99999 - 10000) + 10000);

                        var totalItensKit = $('.divKit .productKit').length;

                        $('.divKit .productKit').each(function( index ) {
                            //var thisSC = $(this).find('.inputSC');
                            var variantIdsCurrent = $(this).attr('data-variantid');

                            var props = {
                                namekit: '', 
                                finalPricekit: '', 
                                comparePricekit: '',
                                totalItensKit: totalItensKit
                                // tenant_id: '',
                                // product_id: '',
                                // product_client_code: '',
                                // seller_id: '',
                                // seller_name: '',
                                // warehouse_id: '',
                                // seller_warehouse_name: '',
                                // diameter: '',
                                // height: '',
                                // length: '',
                                // width: '',
                                // variation_id: ''
                            };
                            //add properties KIT
                             props.namekit = $('.divKit').attr('data-handle');
                             props.finalPricekit = $('.calcPriceKit #ProductPrice-product-template .value').text();
                             props.comparePricekit = $('.calcPriceKit #ComparePrice-product-template .value').text();
                            // //add properties SellerCenter
                            // props.tenant_id = thisSC.find('[name="properties[tenant_id]"]').val();
                            // props.product_id = thisSC.find('[name="properties[product_id]"]').val();
                            // props.product_client_code = thisSC.find('[name="properties[product_client_code]"]').val();
                            // props.seller_id = thisSC.find('[name="properties[seller_id]"]').val();
                            // props.seller_name = thisSC.find('[name="properties[seller_name]"]').val();
                            // props.warehouse_id = thisSC.find('[name="properties[warehouse_id]"]').val();
                            // props.seller_warehouse_name = thisSC.find('[name="properties[seller_warehouse_name]"]').val();
                            // props.diameter = thisSC.find('[name="properties[diameter]"]').val();
                            // props.height = thisSC.find('[name="properties[height]"]').val();
                            // props.length = thisSC.find('[name="properties[length]"]').val();
                            // props.width = thisSC.find('[name="properties[width]"]').val();
                            // props.variation_id = thisSC.find('[name="properties[variation_id]"]').val();
                            // props.id_add = randomNumber;
                            
                            items.push({id: parseInt(variantIdsCurrent), quantity: quantityItems, properties: props})
                            
                        });
                        
                        $.ajax({
                            type: "POST",
                            url: '/cart/add.js?v=' + randomNumber,
                            dataType: 'json',
                            data: {items},
                            success: function(result) {
                                console.log('add', result)
                                $('.modalOverly').hide();
                                $('.loadingBox').hide();

                                //add now
                                if(addNow){
                                    window.location.href = '/checkout';
                                }else{
                                    //add cart
                                    if (window.location.href.indexOf("opencart=true") > -1) {
                                        document.location.reload(true);
                                    }else{
                                        var url = new URL(window.location.href);
                                        url.searchParams.set('opencart','true');
                                        window.location.replace(url.href);
                                    }
                                }
                            },
                            error: function(error) {
                                console.log(error)
                                console.log(error.responseJSON.description);
                                debugger
                                Swal.fire({
                                    icon: 'info',
                                    html: '<p>'+error.responseJSON.description+'</p>',
                                })
                                $('.modalOverly').hide();
                                $('.loadingBox').hide();
                            }
                        });
                    }
                });
            }else{
                $('.modalOverly').hide();
                $('.loadingBox').hide();
                Swal.fire({
                    title: 'Atenção!',
                    text: 'Você precisa selecionar todos os itens do kit para continar!',
                    icon: 'warning'
                })
            }
            return false;
        });
    }

    function calcPriceKit(){
        var finalPriceKit = 0;
        var comparePriceKit = 0;
        var comparePriceKitSum = 0;
        $('.divKit .productKit').each(function( index ) {
            finalPriceKit = finalPriceKit + parseInt($(this).attr('data-final-price'));
            if( $(this).attr('data-compare-price') == '' || $(this).attr('data-compare-price') == undefined ){
                comparePriceKit = parseInt($(this).attr('data-final-price'));
            }else{
                comparePriceKit = parseInt($(this).attr('data-compare-price'));
            }
            comparePriceKitSum = comparePriceKitSum + comparePriceKit;
        })

        $('.calcPriceKit #ProductPrice-product-template .value').text(formatReal(finalPriceKit))
        $('.calcPriceKit #ComparePrice-product-template .value').text(formatReal(comparePriceKitSum))

        $('div[data-kit="true"] #AddToCartText-product-template').attr('data-finalPriceKit', finalPriceKit)
        $('div[data-kit="true"] #AddToCartText-product-template').attr('data-comparePriceKitSum', comparePriceKitSum)
    }

    function removeMinicart(){
        $('.mini-products-list .product-details .remove').on('click', function(){

            var variantId = parseInt($(this).attr('data-variant-id'));
            var thisLine = $(this).closest('li.itemProduct');

            var randomNumber = Math.floor(Math.random() * (99999 - 10000) + 10000);
            $.post('/cart/update.js?v=' + randomNumber, {
                updates: {
                    [variantId]: 0
                }
            }).done(function(result) {
                 result = JSON.parse(result);
                 //atualiza preço total
                $('.cart-subtotal-row .product-price').html('R$ ' + formatReal(result.total_price));
                thisLine.remove();
            }).fail(function() {
                Swal.fire({
                    icon: 'info',
                    html: '<p>Erro ao atualizar produtos.</p>',
                  })
            })
        });
    }

    function updateCart(variantId, qtd){
        var randomNumber = Math.floor(Math.random() * (99999 - 10000) + 10000);
        $.post('/cart/update.js?v=' + randomNumber, {
            updates: {
                [variantId]: qtd
            }
        }).done(function(result) {
            result = JSON.parse(result);
            //atualiza preço total
            $('.site-header__cart-count').text(result.item_count);
            $('.cart-subtotal-row .product-price').html('R$ ' + formatReal(result.total_price));
            $('.modalOverly').hide();
            $('.loadingBox').hide();
        }).fail(function() {
            $('.modalOverly').hide();
            $('.loadingBox').hide();
            Swal.fire({
                icon: 'info',
                html: '<p>Erro ao atualizar produtos.</p>',
              })
        })
    }

    function plusMinusMinicart(){
        //plus qtd
        var currentQtd = 0;
        $('.mini-products-list .qtyField .qtyBtn.plus').on('click', function(){
            $('.modalOverly').show();
            $('.loadingBox').show();
            var currentId = $(this).attr('data-variant-id');

            //plus input
            var currentQtd = parseInt($(this).prev().val());
            currentQtd = currentQtd + 1;
            $(this).prev().val(currentQtd);
            $('a[data-qtd]').css('visibility', 'visible');
            updateCart(currentId, currentQtd);
        });
        //minus qtd
        $('.mini-products-list .qtyField .qtyBtn.minus').on('click', function(){
            $('.modalOverly').show();
            $('.loadingBox').show();
            var currentId = $(this).attr('data-variant-id');

            //minus input
            var currentQtd = parseInt($(this).next().val());
            if(currentQtd > 1){
                currentQtd = currentQtd - 1;
                $(this).next().val(currentQtd);
                debugger
                if(currentQtd == 1){
                    $('a[data-qtd]').css('visibility', 'hidden');
                }
                updateCart(currentId, currentQtd);
            }
        });
    }
    function groupItensKitMinicart(){

        //remove botao comprar agora default
        setTimeout(function(){
            $('.ptContainer[data-kit="true"] .shopify-payment-button__button').remove();
        }, 5000);

        var kitCurrentName = []
        var count = $('.mini-products-list li[data-kit="true"]').length;
        $('.mini-products-list li[data-kit="true"]').each(function (indexEach, item) {
            if (kitCurrentName.includes($(this).attr('data-kitname')) == false){
                var thisCurrent = $(this);
                kitCurrentName.push($(this).attr('data-kitname'));

                var thisHandle = $(this).attr('data-kitname');
                 //atualiza preço total
                $.ajax({
                    type: "GET",
                    url: '/products/'+thisHandle+'.js',
                    dataType: 'json',
                    success: function(product) {
                        console.log(product);
                        var titleProd = product.title;
                        var imgKit = product.images[0]
                        var finalPricekit = '';
                        var comparePriceKit = '';
                        var urlProduct = product.url;

                        //pega nome produtos do kit
                        var arrayProdKit = []
                        $('[data-kitname='+product.handle+']').each(function( index ) {
                            arrayProdKit.push(parseInt($(this).attr('data-variant-id')));
                            $(this).find('.property').each(function( index ) {
                                if($(this).find('.property-label').text() == 'finalPricekit:'){
                                    finalPricekit = $(this).find('.property-label').next().text();
                                }
                                if($(this).find('.property-label').text() == 'comparePricekit:'){
                                    comparePriceKit = $(this).find('.property-label').next().text();
                                }
                            })
                        });
                        var qtdKit = 1;
                        jQuery.getJSON('/cart.js', function(cart) {
                            for (let i = 0; i < cart.items.length; i++) {
                                if(cart.items[i].properties != null){
                                    if(cart.items[i].properties.namekit != undefined){
                                        if(cart.items[i].properties.namekit == thisHandle){
                                            qtdKit = cart.items[i].quantity;
                                        }
                                    }
                                }
                                
                            }
                        }).done(function( data ) {
                            $( `<li class="grid item clearfix itemProduct productKit" data-handleKit="`+product.handle+`">
                                    <div class="image-wrap">
                                        <a class="grid__item one-third medium-up--one-quarter product-image" href="`+urlProduct+`">
                                            <img class="imgFl" alt="`+titleProd+`" src="`+imgKit+`">
                                        </a>
                                    </div>
                                    <div class="grid__item two-thirds medium-up--three-quarters product-details">
                                        <a href="#" title="Remover" class="remove removeKit" data-variant-id="`+arrayProdKit+`"><i class="ad ad-times-sql" aria-hidden="true"></i></a>
                                        <a href="`+urlProduct+`" class="pName">`+titleProd+`</a>
                                        <p class="variant"></p>
                                        <div class="priceRow flex">
                                            <p class="product-price">
                                                <span class="finalPricekit">R$ `+finalPricekit+`</span>
                                                <span class="comparePriceKit">R$ `+comparePriceKit+`</span>
                                            </p>
                                        </div>
                                    </div>
                                </li>`).insertBefore(thisCurrent)
                            })
                        },
                        error: function(error) {
                            console.log(error)
                        }
                });
                
            }
        }).promise().done(function () { 
            setTimeout(function(){
                deleteKitMinicart()
            }, 1000);
        });
        
    }

    function groupItensKitCart(){

        //checa se esta no cart
        if ($('body.template-cart').length){
            $('.modalOverly').show();
            $('.loadingBox').show();
            var kitCurrentName = []
            var count = $('main.cart form.cart .grid__item table').find('[data-namekit]').length;
            $('main.cart form.cart .grid__item table [data-namekit]').each(function (indexEach, item) {
                if (kitCurrentName.includes($(this).attr('data-namekit')) == false){
                    var thisCurrent = $(this);
                    kitCurrentName.push($(this).attr('data-namekit'));
    
                    var thisHandle = $(this).attr('data-namekit');
                     //atualiza preço total
                    $.ajax({
                        type: "GET",
                        url: '/products/'+thisHandle+'.js',
                        dataType: 'json',
                        success: function(product) {
                            console.log(product);
                            var titleProd = product.title;
                            var imgKit = product.images[0]
                            var finalPricekit = '';
                            var comparePriceKit = '';
                            var urlProduct = product.url;
    
                            //pega nome produtos do kit
                            var arrayProdKit = []
                            $('[data-kitname='+product.handle+']').each(function( index ) {
                                arrayProdKit.push(parseInt($(this).attr('data-variant-id')));
                                $(this).find('.property').each(function( index ) {
                                    if($(this).find('.property-label').text() == 'finalPricekit:'){
                                        finalPricekit = $(this).find('.property-label').next().text();
                                    }
                                    if($(this).find('.property-label').text() == 'comparePricekit:'){
                                        comparePriceKit = $(this).find('.property-label').next().text();
                                    }
                                })
                            });
                            var qtdKit = 1;
                            jQuery.getJSON('/cart.js', function(cart) {
                                for (let i = 0; i < cart.items.length; i++) {
                                    if(cart.items[i].properties != null){
                                        if(cart.items[i].properties.namekit != undefined){
                                            if(cart.items[i].properties.namekit == thisHandle){
                                                qtdKit = cart.items[i].quantity;
                                            }
                                        }
                                    }
                                    
                                }
                            }).done(function( data ) {
                                $( `<tr class="cart__row border-bottom cart-flex trKit" data-handleKit="`+product.handle+`">
                                        
                                        <td class="delete small--hide">
                                            <a href="#" title="Remover" class="remove btn removeKitCart" data-variant-id="`+arrayProdKit+`"><i class="ad ad-times-r" aria-hidden="true"></i></a>
                                        </td>
                                
                                        <td>
                                            <div class="image-wrap">
                                                <a class="grid__item one-third medium-up--one-quarter product-image" href="`+urlProduct+`">
                                                    <img class="imgFl" alt="`+titleProd+`" src="`+imgKit+`">
                                                </a>
                                            </div>
                                        </td>
                                        <td class="text-left cart-flex-item nameProd">
                                            <a href="`+urlProduct+`" class="grid-view-item__title"><b>`+titleProd+`</b></a>
                                        </td>
                                        <td>
                                            <div class="priceRow flex">
                                                <p class="product-price">
                                                    <span class="comparePriceKit">R$ `+comparePriceKit+`</span>
                                                </p>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="qtyField">
                                                <input class="qty cart__qty-input" style="width:100%;" type="text" disabled="disabled" value="1">
                                            </div>
                                        </td>
                                        <td>
                                            <div class="priceRow flex">
                                                <p class="product-price">
                                                    <span class="finalPricekit">R$ `+finalPricekit+`</span>
                                                </p>
                                            </div>
                                        </td>

                                    </tr>`).insertBefore(thisCurrent)
                                })
                                setTimeout(function(){
                                    $('.modalOverly').hide();
                                    $('.loadingBox').hide();
                                }, 1500);
                            },
                            error: function(error) {
                                console.log(error)
                            }
                    });
                    
                }
            }).promise().done(function () { 
                setTimeout(function(){
                    deleteKitCart()
                    $('.modalOverly').hide();
                    $('.loadingBox').hide();
                }, 2500);
            });
        }
        
    }

    function openCart(){
        if (window.location.href.indexOf("opencart") > -1) {
            setTimeout(function(){
                $('#openCart').trigger('click');
            }, 1000);
            setTimeout(function() {
                $(".block-cart").removeClass("active");
                let url = location.href;
                let params = new URLSearchParams(url.search);
                params.delete('opencart'); //Query string is now: 'bar=2'
             }, 7000);
        }
    }

    function removeItensKit(startDel, countTotal, reloadPage){
        if (countTotal > 0){
            var randomNumber = Math.floor(Math.random() * (99999 - 10000) + 10000);
            $.ajax({
                type: "POST",
                url: '/cart/change.js?v=' + randomNumber,
                dataType: 'json',
                data: { quantity: 0, line: startDel},
                success: function(result) {
                    setTimeout(function(){
                        removeItensKit(startDel, countTotal - 1, reloadPage)
                        //atualiza itens e preço minicart
                        $('.site-header__cart-count').text(result.item_count);
                        $('.cart-subtotal-row .product-price').html('R$ ' + formatReal(result.total_price));
                        $('.modalOverly').hide();
                        $('.loadingBox').hide();
                        if(startDel == countTotal){
                            if(reloadPage){
                                document.location.reload(true);
                            }
                        }
                    }, 300);
                }
            });
        }
    }


    
    function deleteKitMinicart(){
        $('.mini-products-list .removeKit').on('click', function(){
            var thisLi = $(this).closest('.productKit');
            var thisHandleKit = thisLi.attr('data-handleKit');
            //var formData = {};
            var productID;
            var productIDS = $(this).attr('data-variant-id').split(',');

            var count = 0;
            var countTotal = 0;
            var startDel = 0;
            for (productID in productIDS) {
                $('.mini-products-list li.grid:not(.productKit)').each(function (indexEach, item) {

                    if( $(this).attr('data-variant-id') == productIDS[productID] && $(this).attr('data-kitname') == thisHandleKit){
                        countTotal = countTotal + 1;
                        if(count == 0){
                            startDel = indexEach + 1;
                            count = count + 1;
                        }
                        
                        item.remove();
                        thisLi.remove();

                    }
                });
            }
            removeItensKit(startDel, countTotal, false)
        });
    }

    function deleteKitCart(){
        $('.cart .removeKitCart').on('click', function(){
            $('.modalOverly').show();
            $('.loadingBox').show();
            var thisTr = $(this).closest('tr[data-handlekit]');
            var thisHandleKit = thisTr.attr('data-handlekit');
            //var formData = {};
            var productID;
            var productIDS = $(this).attr('data-variant-id').split(',');

            var count = 0;
            var countTotal = 0;
            var startDel = 0;
            for (productID in productIDS) {
                $('main.cart form.cart .grid__item table tr.itensCart').each(function (indexEach, item) {

                    if( $(this).attr('data-variant-id') == productIDS[productID] && $(this).attr('data-namekit') == thisHandleKit){
                        countTotal = countTotal + 1;
                        if(count == 0){
                            startDel = indexEach + 1;
                            count = count + 1;
                        }
                        
                        item.remove();
                        thisTr.remove();

                    }
                });
            }
            removeItensKit(startDel, countTotal, true)
        });
    }
    
    function changeVariantKit(){
        //get current available variant
        if($('.productKit')[0]){
            $('.productKit').each((idx, itemArr) => {
                let itemKit = $(itemArr);
                const kitImage = itemKit.find('.imgProdKit');
                const productId = itemKit.attr('data-productid');
                const currentItemJson = JSON.parse(itemKit.find('.item-kit-json').html());
                const firstAvailable = currentItemJson.variants.find((x) => {return x.id == parseInt(itemKit.find('.item-kit-json').attr('data-firstavailableid'))})
                
                //seleciona a variacao completa
                itemKit.find('.variants').click((e) => {

                    var thisVariantButton = $(e.currentTarget);
                    thisVariantButton.parent().find('.variants').removeClass('active');
                    thisVariantButton.addClass('active');
        
                    var thisVariantTitle = thisVariantButton.text()
                    thisVariantButton.parent().find('.lblName strong').text(thisVariantTitle);
        
                    var thisVariantId = parseInt(thisVariantButton.attr('data-variantid'));
                    thisVariantButton.closest('.productKit').attr('data-variantid', thisVariantId);
                    
                    var thisProductId = thisVariantButton.closest('.productKit').attr('data-productid');
        
                    //change item image
                    var thisVariantImage = thisVariantButton.attr('data-variantimage'),
                    currentImage = thisVariantButton.closest('.productKit').find('.imgProdKit'),
                    defImage = currentImage.attr('data-defaultimg');
                    if(thisVariantImage != ''){
                        currentImage.attr('src', thisVariantImage)
                    }else{
                        currentImage.attr('src', defImage)
                    }
                    
                    //add variantTenantID nos produtos do kit

                    // for (let x = 0; x < window.VariationMetafields.length; x++) {
                    //     if(window.VariationMetafields[x].product == thisProductId){
                    //         for (let y = 0; y < window.VariationMetafields[x].variants.length; y++) {
                    //             if(window.VariationMetafields[x].variants[y].var_id == thisVariantId){
                    //                 thisVariantButton.closest('.productKit').find('.inputSC input[name="properties[variation_id]"]').val(window.VariationMetafields[x].variants[y].var_variation_id)
                    //             }
                    //         }
                    //     }
                    //  }
                });

                let returnVariantsValues = (objItems) => {
                    let iptOpt1 = itemKit.find(`.swatchInput[name="option-${productId}-0"]:checked`),
                        iptOpt2 = itemKit.find(`.swatchInput[name="option-${productId}-1"]:checked`),
                        iptOpt3 = itemKit.find(`.swatchInput[name="option-${productId}-2"]:checked`);

                    let filteredObj = objItems.variants.filter((x) => {
                        
                        if(iptOpt1.val() && !iptOpt2.val() && !iptOpt3.val()){
                            return x.option1 == iptOpt1.val();
                        }else if(iptOpt1.val() && iptOpt2.val() && !iptOpt3.val()){
                            return x.option1 == iptOpt1.val() && x.option2 == iptOpt2.val();
                        }else if(iptOpt1.val() && iptOpt2.val() && iptOpt3.val()){
                            return x.option1 == iptOpt1.val() && x.option2 == iptOpt2.val() && x.option3 == itemValue;
                        }
                        
                    })
                    return filteredObj;
                }

                //funcao de clique nas opcoes variacoes
                itemKit.find('.swatch-element input').click((e) => {
                    let item = $(e.currentTarget);
                    let itemValue = item.val();
                    let optIdx = parseInt(item.parents('.swatch').attr('data-option-index'));
                    const qtdOpts = itemKit.find('.swatch').length;

                    item.parents('.swatch').find('.slVariant').html(itemValue);
                    
                    item.parents('.swatch').addClass('is-selected');

                    let iptOpt1 = itemKit.find(`.swatchInput[name="option-${productId}-0"]:checked`),
                        iptOpt2 = itemKit.find(`.swatchInput[name="option-${productId}-1"]:checked`),
                        iptOpt3 = itemKit.find(`.swatchInput[name="option-${productId}-2"]:checked`),
                        noCombinations = false;

                    let selectedVariants = returnVariantsValues(currentItemJson, iptOpt1, iptOpt2, iptOpt3)

                    if(selectedVariants.length == 0){
                        if(iptOpt2[0]){
                            console.log('entrou op2', iptOpt2[0])
                            iptOpt2.prop('checked', false);
                        }
                        if(iptOpt3[0]){
                            iptOpt3.prop('checked', false);
                        }

                        selectedVariants = returnVariantsValues(currentItemJson)
                    }


                    //habilita / desabilita outras opcoes
                    if (qtdOpts > 1){
                        const nextIdx = optIdx + 2;
                        const nextOpt = currentItemJson.variants.map((x) => { 
                            if(x['option' + (optIdx + 1)] == selectedVariants[0].options[optIdx]){
                                return x['option' + nextIdx]
                            }else{
                                return null
                            }
                        });
                        itemKit.find(`.swatch.option${nextIdx} .swatch-element`).removeClass('soldout');
                        itemKit.find(`.swatch.option${nextIdx} .swatch-element input`).attr('disabled', false);
                        // itemKit.find(`.swatch.option${nextIdx} .swatch-element input`).prop('checked', false);
                        // itemKit.find(`.swatch.option${nextIdx}`).removeClass('is-selected')
                        itemKit.find(`.swatch.option${nextIdx} .swatch-element`).each((idx, itemOpt) => {
                            if(nextOpt.findIndex((x) => {return x == $(itemOpt).attr('data-value')}) == -1){
                                $(itemOpt).addClass('soldout');
                                $(itemOpt).find('input').attr('disabled', true);
                            }
                        })
                        //descarma a varicacao seleciona e volta imagem padrao
                        // itemKit.find('.variants.active').removeClass('active');
                        // kitImage.attr('src', kitImage.attr('data-defaultimg'));
                    }

                    let isAllSelected = itemKit.find('.swatch.is-selected').length == qtdOpts ? true : false;

                    if(selectedVariants.length == 1 && isAllSelected)
                        itemKit.find(`.variants[data-variantid="${selectedVariants[0].id}"]`).click();
                })

                //seleciona primeiro item disponivel
                // debugger;
                for(var i = 1; i <= 3; i++){
                    if(firstAvailable[`option${i}`]){
                        const currentVal = firstAvailable[`option${i}`];
                        itemKit.find(`.swatch.option${i} .swatch-element[data-value="${currentVal}"] input`).click()
                    }
                }

                

                
            })
        }

        

        // $('.productKit .infoProdKit .variants').eq(0).click();
    }

    function changeVariantProduct(){
        $('.product-single__meta .swatch-element').on('click', function(){
            setTimeout(function(){
                var urlParams = new URLSearchParams(window.location.search),
                variantId = urlParams.get('variant');
                // debugger
                window.customSCUpdate(variantId)
            }, 500);
        });
    }

    function checkItensKitEqual(){
        jQuery.getJSON('/cart.js', function(cart) {
           
            for (let i = 0; i < cart.items.length; i++) {
                if(cart.items[i].properties != null){
                    if(cart.items[i].properties.namekit != undefined){
                        var totalKit = parseInt(cart.items[i].properties.totalItensKit);
                        var nameKit = cart.items[i].properties.namekit;
                        var totalCurrentKit = 0;
                        
                        for (let x = 0; x < cart.items.length; x++) {
                            if(cart.items[x].properties.namekit == nameKit){
                                totalCurrentKit = totalCurrentKit + 1;
                            }
                        }
                    }
                }
            }
            if(totalCurrentKit != totalKit){
                $.ajax({
                    type: "POST",
                    url: '/cart/clear.js',
                    success: function(){
                        Swal.fire({
                            icon: 'info',
                            html: '<p>O kit só pode ser comprado completo. Por favor, tente adicioná-lo novamente.</p>',
                          })
                        if (window.location.href.indexOf("opencart=true") > -1) {
                            var urlNoParameter = window.location.href.split('?')[0]
                            window.location.href = urlNoParameter;
                        }else{
                            document.location.reload(true);
                        }
                    },
                    dataType: 'json'
                });
            }

         });
    }
    
    function cartQuant(){
        $('.cart .qtyField .qtyBtn.plus').on('click', function(){
            $('.modalOverly').show();
            $('.loadingBox').show();
            var currentQtd = parseInt($(this).prev().val());
            currentQtd = currentQtd + 1;
            var variantId = parseInt($(this).closest('tr[data-variant-id]').attr('data-variant-id'));
            var thisInpit = $(this).prev();
            $.post('/cart/update.js', {
                updates: {
                    [variantId]: currentQtd
                }
            }).done(function(result) {
                thisInpit.val(currentQtd);
                document.location.reload(true);
            }).fail(function() {
                $('.modalOverly').hide();
                $('.loadingBox').hide();
                Swal.fire({
                    icon: 'info',
                    html: '<p>Erro ao atualizar produtos.</p>',
                  })
            })
        });
        $('.cart .qtyField .qtyBtn.minus').on('click', function(){
            $('.modalOverly').show();
            $('.loadingBox').show();
            var currentQtd = parseInt($(this).next().val());
            if(currentQtd > 1){
                currentQtd = currentQtd - 1;
                var variantId = parseInt($(this).closest('tr[data-variant-id]').attr('data-variant-id'));
                var thisInpit = $(this).prev();
                $.post('/cart/update.js', {
                    updates: {
                        [variantId]: currentQtd
                    }
                }).done(function(result) {
                    thisInpit.val(currentQtd);
                    document.location.reload(true);
                }).fail(function() {
                    $('.modalOverly').hide();
                    $('.loadingBox').hide();
                    Swal.fire({
                        icon: 'info',
                        html: '<p>Erro ao atualizar produtos.</p>',
                    })
                })
            }
        });
    }

    function AddressValidator(){
        if( $('#AddressZipNew').length){
            VMasker(document.querySelector("#AddressZipNew")).maskPattern("99999-999");
        }

        function limpa_formulário_cep() {
            // Limpa valores do formulário de cep.
            $("#AddressAddress1New").val("");
            $("#AddressCityNew").val("");
            $("#AddressProvinceNew").val("");
        }
        
        //Quando o campo cep perde o foco.
        $("#AddressZipNew").blur(function() {

            //Nova variável "cep" somente com dígitos.
            var cep = $(this).val().replace(/\D/g, '');

            //Verifica se campo cep possui valor informado.
            if (cep != "") {

                //Expressão regular para validar o CEP.
                var validacep = /^[0-9]{8}$/;

                //Valida o formato do CEP.
                if(validacep.test(cep)) {

                    //Preenche os campos com "..." enquanto consulta webservice.
                    $("#AddressAddress1New").val("...");
                    $("#AddressCityNew").val("...");
                    $("#AddressProvinceNew").val("...");


                    //Consulta o webservice viacep.com.br/
                    $.getJSON("https://viacep.com.br/ws/"+ cep +"/json/?callback=?", function(dados) {

                        if (!("erro" in dados)) {
                            //Atualiza os campos com os valores da consulta.
                            $("#AddressAddress1New").val(dados.logradouro);
                            $("#AddressCityNew").val(dados.localidade);
                            
                            var dataUf = '';
                            switch (dados.uf.toUpperCase()) {
                                /* UFs */
                                case "AC" :	dataUf = "Acre";					break;
                                case "AL" :	dataUf = "Alagoas";				break;
                                case "AM" :	dataUf = "Amazonas";				break;
                                case "AP" :	dataUf = "Amapá";					break;
                                case "BA" :	dataUf = "Bahia";					break;
                                case "CE" :	dataUf = "Ceará";					break;
                                case "DF" :	dataUf = "Distrito Federal";		break;
                                case "ES" :	dataUf = "Espírito Santo";		break;
                                case "GO" :	dataUf = "Goiás";					break;
                                case "MA" :	dataUf = "Maranhão";				break;
                                case "MG" :	dataUf = "Minas Gerais";			break;
                                case "MS" :	dataUf = "Mato Grosso do Sul";	break;
                                case "MT" :	dataUf = "Mato Grosso";			break;
                                case "PA" :	dataUf = "Pará";					break;
                                case "PB" :	dataUf = "Paraíba";				break;
                                case "PE" :	dataUf = "Pernambuco";			break;
                                case "PI" :	dataUf = "Piauí";					break;
                                case "PR" :	dataUf = "Paraná";				break;
                                case "RJ" :	dataUf = "Rio de Janeiro";		break;
                                case "RN" :	dataUf = "Rio Grande do Norte";	break;
                                case "RO" :	dataUf = "Rondônia";				break;
                                case "RR" :	dataUf = "Roraima";				break;
                                case "RS" :	dataUf = "Rio Grande do Sul";		break;
                                case "SC" :	dataUf = "Santa Catarina";		break;
                                case "SE" :	dataUf = "Sergipe";				break;
                                case "SP" :	dataUf = "São Paulo";				break;
                                case "TO" :	dataUf = "Tocantíns";	
                            }

                            $("#AddressProvinceNew").val(dataUf);
                        } //end if.
                        else {
                            //CEP pesquisado não foi encontrado.
                            limpa_formulário_cep();
                            alert("CEP não encontrado.");
                        }
                    });
                } //end if.
                else {
                    //cep é inválido.
                    limpa_formulário_cep();
                    alert("Formato de CEP inválido.");
                }
            } //end if.
            else {
                //cep sem valor, limpa formulário.
                limpa_formulário_cep();
            }
        });

        $('.address-edit-toggle').on('click', function(){
            var endereco = $(this).closest('.address').next().find('input[name="address[address1]"]').val();
            var numero = $(this).closest('.address').next().find('#AddressNumber').val();

            if (endereco.indexOf(',') > 0){
                endereco = endereco.split(',')
                $(this).closest('.address').next().find('input[name="address[address1]"]').val(endereco[0].trim());
                $(this).closest('.address').next().find('#AddressNumber').val(endereco[1].trim());
            }
        });

        /*$('.form-vertical .btn, .form-vertical [type=submit]').on('click', function(){
            if( $(this).closest('form').find('input[name="address[address1]"]').val() == ''){
                Swal.fire({
                    icon: 'info',
                    html: '<p>Digete o endereço.</p>',
                })
                $(this).closest('form').find('input[name="address[address1]"]').addClass('error');
                return false;
            }else{
                $(this).closest('form').find('input[name="address[address1]"]').removeClass('error');
            }

            if( $(this).closest('form').find('#AddressNumber').val() == ''){
                Swal.fire({
                    icon: 'info',
                    html: '<p>Digete o número.</p>',
                })
                $(this).closest('form').find('#AddressNumber').addClass('error');
                return false;
            }else{
                $(this).closest('form').find('#AddressNumber').removeClass('error');
            }

            if($(this).closest('form').find('#AddressNumber').val() != '' || $(this).closest('form').find('input[name="address[address1]"]').val() != ''){
                
                var endereco = $(this).closest('form').find('input[name="address[address1]"]').val();
                var numero = $(this).closest('form').find('#AddressNumber').val();
                var bairro = $(this).closest('form').find('input[name="address[district]"]').val();

                if (endereco.indexOf(numero) < 0){
                    var enderecoNum = endereco + ', ' + numero + ' - ' bairro;
                    $(this).closest('form').find('input[name="address[address1]"]').val(enderecoNum)

                }

            }
            
        });*/
    }
    function cleanCart(){
        $('.cleanCart').on('click', function(){
            $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                data: '',
                dataType: 'json',
                success: function() { 
                  location.reload();
                },
                error: function(XMLHttpRequest, textStatus) {
                  /* error code */
                }
              });
        });
    }

    var OrderVariants = function(VariantParent, VariantChild){
        var alphaSize = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 'PP', 'P', 'M', 'G', 'GG', 'XG', 'Baby Look PP', 'Baby Look P', 'Baby Look M', 'Baby Look G', 'Baby Look GG', 'Baby Look XG'];
        $(VariantParent).each(function(){
            var parentEl = $(this);
            $(this).find(VariantChild).filter(function(){
                var w = $.inArray( $(this).data('value'), alphaSize);
                console.table($(this).data('value'), w)
                if (w > -1) {
                    $(this).attr('data-sortindex', w);
                    return true;
                }
                else {
                    if($.isNumeric($(this).data('value'))){
                        $(this).attr('data-sortindex', $(this).data('value'));
                        return true;
                    }else{
                        return false;
                    }
                }
            })
            .sort(function(a, b){
                return $(a).data('sortindex') - 
                    $(b).data('sortindex');
            })
            .appendTo(parentEl);
        });
    }

    const reorderVariants = () => {
        var parentEl = $('.swatch');
        parentEl.each((idx, item) => {
            OrderVariants(item, '.swatch-element')
        })
    }


    //chamada das funcoes
    calcPriceKit();
    addCartKit();
    removeMinicart();
    plusMinusMinicart();
    groupItensKitMinicart();
    groupItensKitCart();
    openCart();
    changeVariantKit();
    changeVariantProduct();
    checkItensKitEqual();
    cartQuant();
    AddressValidator();
    cleanCart();
    reorderVariants();
     
     //hide account on franqueados
     if(window.location.href.indexOf('collections/franqueados') > -1) {
       $('.login-register').parent().attr('id', 'pageFranqueados')
       $('.login-register .flex-item').eq(0).addClass('franqueadoLogin')
       $('.login-register .flex-item').eq(1).addClass('franqueadoCadastro')
     }
})();
